export enum BookingApprovalStatus {
  Approved = 0,
  Pending = 1,
  Rejected = 2,
}

export interface Booking {
  id: number;
  title: string;
  startTime: string;
  endTime: string;
  venueId?: number | null;
  venueName?: string | null;
  /** Foglalt pályarészek CSV-ben; üres = az egész pálya. */
  venueSections?: string | null;
  /** Kinek a nevére szól a foglalás. */
  guestTeam?: string | null;
  approvalStatus: BookingApprovalStatus;
  rejectionReason?: string | null;
  reviewedAt?: string | null;
  createdByUserId: number;
  createdByUserName: string;
  createdAt: string;
}

export interface CreateBookingRequest {
  title: string;
  startTime: string;
  endTime: string;
  venueId?: number;
  venueSections?: string;
}

export const bookingStatusLabel = (status: BookingApprovalStatus): string => {
  switch (status) {
    case BookingApprovalStatus.Approved:
      return 'Jóváhagyva';
    case BookingApprovalStatus.Rejected:
      return 'Elutasítva';
    default:
      return 'Jóváhagyásra vár';
  }
};

export const bookingStatusClass = (status: BookingApprovalStatus): string => {
  switch (status) {
    case BookingApprovalStatus.Approved:
      return 'bg-green-100 text-green-800';
    case BookingApprovalStatus.Rejected:
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-amber-100 text-amber-800';
  }
};
